module.exports = "https://www.gc-qa.gnp.com.mx/72e3c680965242ce7438a27938d00cae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/reporte-siniestro.svg
// module id = 8164
// module chunks = 0